// Один попап класса. Занятия берутся из template выбранной колонки и прокручиваются к мастер-классу.
export class ProgramClass {
	constructor(popupController) {
		this.popup = document.querySelector('[data-popup-name="program-class"]')
		if (!this.popup) return

		this.controller = popupController
		this.card = this.popup.querySelector('[data-program-class]')
		this.scroller = this.popup.querySelector('[data-popup-scroll]')
		this.days = Array.from(document.querySelectorAll('[data-program-day]'))
		this.route = null
		this.returnHash = ''
		this.historyOwned = false
		this.closingFromUrl = false

		this.popup.addEventListener('popup:open', (e) => {
			const route = this.routeFromTrigger(e.detail.trigger) || this.readRoute()
			if (!route) return

			const previousHash = window.location.hash
			this.returnHash = this.readRoute() ? `#program-day-${route.day}` : previousHash
			this.route = route
			this.render()
			if (previousHash !== this.hashFor(route)) {
				this.historyOwned = true
				this.writeUrl(route, 'pushState')
			} else {
				this.historyOwned = Boolean(window.history.state && window.history.state.schoolProgramPopup)
			}
		})
		this.popup.addEventListener('popup:ready', () => this.scrollToLesson(true))

		this.popup.addEventListener('popup:close', () => {
			const fromUrl = this.closingFromUrl
			this.closingFromUrl = false
			if (!fromUrl && this.readRoute()) {
				if (this.historyOwned) {
					window.history.back()
				} else {
					const url = new URL(window.location.href)
					url.hash = this.returnHash
					window.history.replaceState(this.historyState(false), '', url)
					this.returnToSchedule()
				}
			}
			this.route = null
			if (fromUrl) this.syncRoute()
		})

		this.popup.querySelectorAll('[data-program-class-step]').forEach((button) => {
			button.addEventListener('click', () => {
				if (!this.route) return
				const columns = this.columnsFor(this.route.day)
				const index = columns.findIndex((column) => column.dataset.programClassId === this.route.classId)
				const column = columns[index + Number(button.dataset.programClassStep)]
				if (!column) return
				this.route = { day: this.route.day, classId: column.dataset.programClassId, lesson: null }
				this.render()
				this.writeUrl(this.route, 'replaceState')
				this.scrollToLesson()
			})
		})

		// Свободная область колонки тоже открывает класс; кнопки внутри обрабатывает Popup
		document.addEventListener('click', (e) => {
			if (e.target.closest('button, a, input, .program__card--stub') || this.controller.activePopup) return
			const column = e.target.closest('[data-program-column]')
			if (column) this.controller.open(this.popup, column.querySelector('[data-popup-open]'))
		})

		window.addEventListener('popstate', () => this.syncRoute())
		window.addEventListener('hashchange', () => this.syncRoute())
		this.syncRoute()
	}

	columnsFor(day) {
		const element = this.days.find((item) => item.id === `program-day-${day}`)
		return element ? Array.from(element.querySelectorAll('[data-program-column]')) : []
	}

	routeFromTrigger(trigger) {
		if (!trigger) return null
		const column = trigger.closest('[data-program-column]')
		const day = trigger.closest('[data-program-day]')
		if (!column || !day) return null
		return {
			day: Number(day.id.replace('program-day-', '')),
			classId: column.dataset.programClassId,
			lesson: Number(trigger.dataset.programLessonOpen) || null
		}
	}

	readRoute() {
		const match = window.location.hash.match(/^#day-(\d+)\/class-(\d+|online(?:-\d+)?)(?:\/lesson-(\d+))?$/)
		if (!match) return null
		const route = { day: Number(match[1]), classId: match[2], lesson: Number(match[3]) || null }
		return this.columnsFor(route.day).some((column) => column.dataset.programClassId === route.classId) ? route : null
	}

	hashFor(route) {
		return `#day-${route.day}/class-${route.classId}${route.lesson ? `/lesson-${route.lesson}` : ''}`
	}

	historyState(open) {
		const state = { ...window.history.state }
		if (open) state.schoolProgramPopup = true
		else delete state.schoolProgramPopup
		return state
	}

	writeUrl(route, method) {
		const url = new URL(window.location.href)
		url.hash = this.hashFor(route)
		window.history[method](this.historyState(this.historyOwned), '', url)
	}

	returnToSchedule() {
		const columns = this.columnsFor(this.route.day)
		const column = columns.find((item) => item.dataset.programClassId === this.route.classId)
		if (!column) return
		const day = column.closest('[data-program-day]')
		day.open = true
		window.requestAnimationFrame(() => {
			const scroller = day.querySelector('[data-program-scroller]')
			scroller.scrollTo({ left: column.offsetLeft - columns[0].offsetLeft, behavior: 'instant' })
			day.scrollIntoView({ block: 'start', behavior: 'instant' })
			column.querySelector('.program__column-head').focus({ preventScroll: true })
		})
	}

	syncRoute() {
		const route = this.readRoute()
		if (!route) {
			if (this.popup.open) {
				this.closingFromUrl = true
				this.controller.close(this.popup)
			}
			return
		}
		if (this.controller.closing && this.popup.open) {
			this.closingFromUrl = true
			return
		}
		if (this.popup.open) {
			this.historyOwned = Boolean(window.history.state && window.history.state.schoolProgramPopup)
			if (!this.historyOwned) this.returnHash = `#program-day-${route.day}`
			this.route = route
			this.render()
			this.scrollToLesson()
		} else if (!this.controller.activePopup) {
			this.controller.open(this.popup, null)
		}
	}

	render() {
		const columns = this.columnsFor(this.route.day)
		const index = columns.findIndex((column) => column.dataset.programClassId === this.route.classId)
		const column = columns[index]
		if (!column) return
		const lessonsBox = this.popup.querySelector('.program-class__lessons')
		const source = column.querySelector('template[data-program-class-body]')
		if (lessonsBox && source) {
			lessonsBox.innerHTML = ''
			lessonsBox.appendChild(source.content.cloneNode(true))
		}
		const online = String(this.route.classId).indexOf('online') === 0
		const date = column.closest('[data-program-day]').querySelector('.program__date').textContent.trim()
		this.card.dataset.theme = column.dataset.programTheme
		const icon = column.querySelector('.program__column-icon svg')
		const iconNode = this.popup.querySelector('.program-class__icon')
		iconNode.replaceChildren()
		if (icon) iconNode.appendChild(icon.cloneNode(true))
		this.popup.querySelector('[data-program-class-title]').textContent = column.querySelector('.program__class-title').textContent.trim()
		this.popup.querySelector('[data-program-class-format]').textContent = online ? 'Онлайн-формат' : 'Аудиторный класс'
		this.popup.querySelectorAll('[data-program-lesson-date]').forEach((element) => { element.textContent = date })
		this.popup.querySelectorAll('[data-program-class-step]').forEach((button) => {
			const previous = Number(button.dataset.programClassStep) < 0
			const target = columns[index + (previous ? -1 : 1)]
			const label = previous ? 'Предыдущий класс' : 'Следующий класс'
			button.disabled = !target
			button.setAttribute('aria-label', target ? `${previous ? 'Предыдущий' : 'Следующий'}: ${target.querySelector('.program__class-title').textContent.trim()}` : label)
		})
	}

	scrollToLesson(immediate = false) {
		const position = () => {
			if (!this.popup.open || !this.route) return
			if (!this.route.lesson) {
				this.scroller.scrollTop = 0
				this.card.focus({ preventScroll: true })
				return
			}
			const lesson = this.popup.querySelector(`[data-program-lesson="${this.route.lesson}"]`)
			if (!lesson) return
			if (lesson === this.popup.querySelector('[data-program-lesson]')) {
				this.scroller.scrollTop = 0
				lesson.focus({ preventScroll: true })
				return
			}
			const sticky = window.matchMedia('(min-width: 1024px)').matches ? this.popup.querySelector('.program-class__head') : this.popup.querySelector('.program-class__nav--top')
			const top = this.scroller.scrollTop + lesson.getBoundingClientRect().top - this.scroller.getBoundingClientRect().top - sticky.offsetHeight - 16
			this.scroller.scrollTo({ top, behavior: 'instant' })
			lesson.focus({ preventScroll: true })
		}
		if (immediate) position()
		else window.requestAnimationFrame(position)
	}
}
